import type { TourConfig } from './types';

export const counsellingTour: TourConfig = {
  id: 'counselling-page',
  name: 'Counselling Tour',
  description: 'Learn how to manage counselling sessions',
  requiredPath: '/dashboard/counselling',
  steps: [
    {
      element: '[data-tour="counselling-header"]',
      popover: {
        title: 'Counselling Sessions',
        description:
          'Schedule and manage client counselling sessions from this page.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="counselling-schedule-button"]',
      popover: {
        title: 'Schedule Session',
        description:
          'Click here to schedule a new counselling session with a client.',
        side: 'bottom',
        align: 'end',
      },
    },
    {
      element: '[data-tour="counselling-search"]',
      popover: {
        title: 'Search Sessions',
        description: 'Search sessions by client code or client name.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="counselling-status-filter"]',
      popover: {
        title: 'Filter by Status',
        description:
          'Filter sessions by status: Scheduled, In Progress, Completed, Cancelled, or No Show.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="counselling-table"]',
      popover: {
        title: 'Sessions Table',
        description:
          'View all counselling sessions here. Sort by client, date, or status, and use the actions menu for more options.',
        side: 'top',
        align: 'center',
      },
    },
  ],
};
